<app-main-menu-horizontal *ngIf="!isVerticalDisplay"></app-main-menu-horizontal>
<app-main-menu-vertical *ngIf="isVerticalDisplay"></app-main-menu-vertical>

<custom-modal #modal></custom-modal>
